<template>
  <Nav />
  <Chat />
  <Concept />

  <!-- <transition name="fade" mode="out-in">   
    <component v-if="dialog" :is="dialog.name" @close="closeDialog" 
      :dialogData="dialog.dialogData"></component>
  </transition> -->
</template>

<script>
import Nav from '@/components/Nav.vue'
import Chat from '@/components/Chat.vue'
//Dialog
import Concept from "@/components/Dialog/Concept.vue";

export default {
  name: 'App',
  components: {
    Nav, Chat,
    Concept
  }
}
</script>
